<h1 mat-dialog-title>
</h1>

<div mat-dialog-content>
  <div class="table-container">

    <div class="table-box">
      <table mat-table [dataSource]="jobHistoryEntries">

        <ng-container matColumnDef="createdAt" sticky>
          <th mat-header-cell *matHeaderCellDef>Created Date</th>
          <td mat-cell *matCellDef="let row">{{row.createdAt | date:'yyyy-MM-dd HH:mm:ss'}}</td>
        </ng-container>

        <ng-container matColumnDef="transactionDate">
          <th mat-header-cell *matHeaderCellDef>Transaction Date</th>
          <td mat-cell
              *matCellDef="let row">{{row.transactionDate | date:'MM-dd-yyyy':'UTC'}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row" [matTooltip]="row.error">
            <span [ngClass]="row.status == 'ERROR' ? 'red-notice cursor-default' : (row.status == 'SUCCESS' ? 'green-notice' : '')">{{row.status}}</span>
            <mat-icon *ngIf="row.status == 'ERROR'" class="font-18">help_outline</mat-icon>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Close</button>
</div>
